import { render, staticRenderFns } from "./LotDiv.vue?vue&type=template&id=8827212c"
import script from "./LotDiv.vue?vue&type=script&lang=js"
export * from "./LotDiv.vue?vue&type=script&lang=js"
import style0 from "./LotDiv.vue?vue&type=style&index=0&id=8827212c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports